import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import _ from 'lodash';

const LOCALE_PREFIX = 'GB/pages/LandingPage/HowItWorks';

export class HowItWorks extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
    };
    render() {
        return (
            <div className="how-it-works-container">
                <div className="how-it-works-header">
                    <FormattedHTMLMessage id={`${LOCALE_PREFIX}.header`} />
                </div>
                <ul className="how-it-works-list">
                    {_.times(3, i => (
                        <li className={`list-item-${i}`} key={`bullet${i}`}>
                            <FormattedHTMLMessage id={`${LOCALE_PREFIX}.bullet${i}`} />
                        </li>
                    ))}
                </ul>
                <div className="representative-container">
                    <div className="representative-header">
                        <FormattedHTMLMessage id={`${LOCALE_PREFIX}.representativeHeader`} />
                    </div>
                    <dl>
                        {_.times(3, i => (
                            <React.Fragment key={`representativeExample${i}`}>
                                <dt>
                                    <FormattedHTMLMessage id={`${LOCALE_PREFIX}.representativeExample${i}Name`} />
                                </dt>
                                <dd>
                                    <FormattedHTMLMessage id={`${LOCALE_PREFIX}.representativeExample${i}Description`} />
                                </dd>
                            </React.Fragment>
                        ))}
                    </dl>
                </div>
                <div className="representative-footer">
                    <FormattedHTMLMessage id={`${LOCALE_PREFIX}.representativeFooter`} />
                </div>
                <div>
                    <FormattedHTMLMessage id={`${LOCALE_PREFIX}.howItWorksFooter`} />
                </div>
            </div>
        );
    }
}

export default connect()(injectIntl(HowItWorks));
